// ESM-Huelle fuer lib/scripts/components/CMP_COverlay.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function COverlay (id)
{
    this.construct (id);

    this.name = "COverlay";
    this.htmlType = "div";
    
    this.properties =
    {
        styles:
        {
            position: "absolute",
            top: "0px",
            left: "0px",
            height: "100%",
            width: "100%",
            backgroundColor: "background:rgba(255,255,255,0.5);",
            //opacity: "0",
            visibility: "hidden",
            zIndex: "9"
        }
    }
}

COverlay.prototype = new CComponent;

COverlay.prototype.show = function()
{
    this.properties.styles.visibility = "visible";
    this.reStyle();
}

COverlay.prototype.hide = function()
{
    this.properties.styles.visibility = "hidden";
    this.reStyle();
}

export { COverlay };
